export { CourseSettings } from './course-settings';
export { UserSettings } from './user-settings';
export { SettingsManager } from './settings-manager.jsx'